import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { useWithAbort } from '../../../util/useWithAbort.js';
import { requestIconWithHash } from '../utility/Icon.helper.js';
import { useFetch } from '../../../contexts/system/BrowserAPI/hooks/useFetch.js';
import { useWindow } from '../../../contexts/system/BrowserAPI/hooks/useWindow.js';
import { useEnvironmentContext } from '../../../contexts/system/Environment.js';
import { useIconContext } from '../../../contexts/system/Icon.js';

/**
 * This hook initializes the icon by fetching it from the CDN or appending it from the local icons
 * @param hash string
 * @returns { isLoaded: boolean }
 */
var useIconInitializer = function useIconInitializer(hash) {
  var environment = useEnvironmentContext();
  var localIcons = useIconContext();
  var fetchAPI = useFetch();
  var window = useWindow();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isLoaded = _React$useState2[0],
    setLoaded = _React$useState2[1];
  var _useWithAbort = useWithAbort(function () {
      return requestIconWithHash(environment.icon, hash, localIcons, fetchAPI, window);
    }),
    requestIconWithAbort = _useWithAbort.start,
    abort = _useWithAbort.abort;
  React.useEffect(function () {
    requestIconWithAbort().then(function () {
      setLoaded(true);
    }).catch(function () {});
    return function () {
      return abort();
    };
  }, [abort, requestIconWithAbort]);
  return {
    isLoaded: isLoaded
  };
};

export { useIconInitializer };
//# sourceMappingURL=useIconInitializer.js.map
